import React, {useState} from "react";
import {Button, Row, Table} from "antd";

import moment from "moment";
import {CreateCallRecordModal} from "./createCallRecordModal/CreateCallRecordModal";
import {courierCallStatusMap} from "../../../../../constants/constants";


export const CourierCallRecords = ({courier, reloadCourier, loading}) => {
    const {callRecords = []} = courier;
    const [visibleCreateCallRecordModal, setVisibleCreateCallRecordModal] = useState(false);

    return (
        <>
            <Button
                type="primary"
                onClick={() => setVisibleCreateCallRecordModal(true)}
                style={{marginBottom: "16px"}}
            >
                Yeni Arama Kaydı Ekle
            </Button>
            <CreateCallRecordModal
                courierId={courier?._id?.toString()}
                isVisible={visibleCreateCallRecordModal}
                setVisible={() => {
                    setVisibleCreateCallRecordModal(!visibleCreateCallRecordModal);
                }}
                onComplete={reloadCourier}
                callStatuses={courierCallStatusMap}
            />
            <Table
                loading={loading}
                pagination={false}
                columns={[
                    {
                        title: "Arama Durumu",
                        render: (_, callRecord) => <Row align="middle">{courierCallStatusMap[callRecord.callStatus] || callRecord.callStatus}</Row>
                    },
                    {
                        title: "Arama Yapan",
                        render: (_, callRecord) => (
                            <Row align="middle">{callRecord.user.fullName}</Row>
                        )
                    },
                    {
                        title: "Detay",
                        render: (_, callRecord) => <Row align="middle">{callRecord.comment}</Row>
                    },
                    {
                        title: "Oluşturulma Tarihi",
                        render: (_, callRecord) => (
                            <Row align="middle">{moment(callRecord.createdAt).format("lll")}</Row>
                        ),
                        sorter: (a, b) => moment(a.createdAt).diff(moment(b.createdAt))
                    }
                ]}
                rowKey={record => record.id}
                dataSource={callRecords
                    .map(callRecord => ({
                        id: callRecord._id.toString(),
                        callStatus: courierCallStatusMap[callRecord.callStatus] || callRecord.callStatus,
                        comment: callRecord.comment,
                        userId: callRecord.userId,
                        user: callRecord.user,
                        createdAt: callRecord.createdAt
                    }))
                    .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))}
            />
        </>
    );
};
